<template>
  <div>
    <div slot="title">
      <h2 class="label-black" v-if="idPregunta == 0">Nueva Pregunta</h2>
      <h2 class="label-black" v-else>Editar Pregunta</h2>
      <span class="col-form-label label-black" v-if="idPregunta == 0">Crea una nueva pregunta y sus respuestas.</span>
      <span class="col-form-label label-black" v-else>Edita la pregunta y sus respuestas.</span>
      <!--<h2 v-if="idFormatoCuestionario==0">Nuevo Cuestionario</h2>
      <h2 v-else>Editar Cuestionario</h2>-->
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:50px;">
          <div class="col-12">
            <div class="row">
              <div class="col-5">
                <div class="row">
                  <div class="col-12">
                    <span class="col-form-label label-black font-weight-bold">Pregunta</span>
                  </div>
                </div>
                <div class="row" style="margin-top:10px">
                  <div class="col-12">
                    <textarea cols="25" rows="3" class="form-control" v-model="pregunta"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-1"></div>
              <div class="col-3">
                <select class="form-control" id="categoriaPregunta" v-model="categoriaPregunta">
                  <option selected disabled value="0">Categoría</option>
                </select>
              </div>
              <div class="col-2">
                <div class="row">
                  <div class="col-2"><input type="checkbox" v-model="todos" /></div>
                  <div class="col-10"><span class="col-form-label label-black">Todos</span></div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-2"><input type="checkbox" v-model="autoevaluacion" /></div>
                  <div class="col-10"><span class="col-form-label label-black">Autoevaluación</span></div>
                </div>
                <div class="row">
                  <div class="col-2"><input type="checkbox" v-model="subordinados" /></div>
                  <div class="col-10"><span class="col-form-label label-black">Subordinados</span></div>
                </div>
                <div class="row">
                  <div class="col-2"><input type="checkbox" v-model="superiores" /></div>
                  <div class="col-10"><span class="col-form-label label-black">Superiores</span></div>
                </div>
                <div class="row">
                  <div class="col-2"><input type="checkbox" v-model="iguales" /></div>
                  <div class="col-10"><span class="col-form-label label-black">Iguales</span></div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-5">
                    <div class="row">
                      <div class="col-12">
                        <span class="col-form-label font-weight-bold label-black">Respuesta 1</span>
                      </div>
                    </div>
                    <div class="row" style="margin-top:10px">
                      <div class="col-12">
                        <textarea cols="25" rows="3" class="form-control" v-model="respuesta1"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-5">
                    <div class="row">
                      <div class="col-12">
                        <span class="col-form-label font-weight-bold label-black">Respuesta 2</span>
                      </div>
                    </div>
                    <div class="row" style="margin-top:10px">
                      <div class="col-12">
                        <textarea cols="25" rows="3" class="form-control" v-model="respuesta2"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top:20px">
                  <div class="col-5">
                    <div class="row">
                      <div class="col-12">
                        <span class="col-form-label font-weight-bold label-black">Respuesta 3</span>
                      </div>
                    </div>
                    <div class="row" style="margin-top:10px">
                      <div class="col-12">
                        <textarea cols="25" rows="3" class="form-control label-black" v-model="respuesta3"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-5">
                    <div class="row">
                      <div class="col-12">
                        <span class="col-form-label font-weight-bold label-black">Respuesta 4</span>
                      </div>
                    </div>
                    <div class="row" style="margin-top:10px">
                      <div class="col-12">
                        <textarea cols="25" rows="3" class="form-control" v-model="respuesta4"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top:20px">
              <div class="col-8"></div>
              <div class="col-3">
                <input type="button" class="form-control btn-custom" value="Guardar Pregunta" v-bind:disabled="deshabilitarBoton" @click="guardarPregunta" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    props: {
      idPregunta:{
        type: Number,
        default: 0
      }
    },
    data() {
      return this.valoresIniciales()
    },
    components: {

    },
    methods: {
      valoresIniciales: function () {
        return {
          todos: false,
          autoevaluacion: false,
          subordinados: false,
          superiores: false,
          iguales: false,
          pregunta: "",
          respuesta1: "",
          respuesta2: "",
          respuesta3: "",
          respuesta4: "",
          preguntaValido: false,
          respuesta1Valido: false,
          respuesta2Valido: false,
          respuesta3Valido: false,
          respuesta4Valido: false,
          categoriaPregunta: "0",
          usuarioId: 1
        }
      },
      validarTextArea: function (str) {
        let remText = str.replace(/ /g, "");
        let length = remText.length;
        return length > 10;
      },
      buscarCompetenciasPreguntas: function () {
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "esPrueba": false
        }
        console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.GetCompetenciasPreguntas, peticion).then(response => {
          if (response.data.SiHayError == false) {
            var categorias = response.data.CategoriasCompetencias
            var select = $('#categoriaPregunta')
            $.each(categorias, function () {
              var group = $('<optgroup label="' + this.Nombre + '" />');
              $(this.Competencias).each(function () {
                $(new Option(this.Nombre, this.CompetenciaPreguntaId)).html(this.Nombre).appendTo(group);
              });
              group.appendTo(select);
            })
            this.precargaPregunta()
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      precargaPregunta: function () {
        if (this.idPregunta != null && this.idPregunta != 0) {
          this.getInfoPregunta();
        }
      },
      guardarPregunta: function () {
        if (this.idPregunta == 0) {
          this.crearPregunta()
        } else {
          this.actualizarPregunta()
        }
      },
      crearPregunta: function () {
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "esPrueba": false,
          "Pregunta": this.pregunta,
          "Respuesta1": this.respuesta1,
          "Respuesta2": this.respuesta2,
          "Respuesta3": this.respuesta3,
          "Respuesta4": this.respuesta4,
          "Autoevaluacion": this.autoevaluacion,
          "Igual": this.iguales,
          "Superior": this.superiores,
          "Subordinado": this.subordinados,
          "CompetenciaPreguntaId": this.categoriaPregunta,
          "Activo": true,
          "usuarioId": this.usuarioId
        }
        console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.CrearPregunta, peticion).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta('Pregunta Guardada Correctamente', null, null)
            Object.assign(this.$data, this.valoresIniciales());
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      actualizarPregunta: function () {
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "idPregunta": this.idPregunta,
          "esPrueba": false,
          "Pregunta": this.pregunta,
          "Respuesta1": this.respuesta1,
          "Respuesta2": this.respuesta2,
          "Respuesta3": this.respuesta3,
          "Respuesta4": this.respuesta4,
          "Autoevaluacion": this.autoevaluacion,
          "Igual": this.iguales,
          "Superior": this.superiores,
          "Subordinado": this.subordinados,
          "CompetenciaPreguntaId": this.categoriaPregunta,
          "Activo": true,
          "usuarioId": this.usuarioId
        }
        console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.ActualizarPregunta, peticion).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta('Pregunta Actualizada Correctamente', null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      getInfoPregunta: function () {
        var peticion = {
          "esPrueba": false,
          "idPregunta": this.idPregunta
        }
        axios.post(api.conexion + api.SISEVA.funcion.GetPregunta, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.pregunta = response.data.Pregunta.DescripcionPregunta
            this.respuesta1 = response.data.Pregunta.Respuesta1
            this.respuesta2 = response.data.Pregunta.Respuesta2
            this.respuesta3 = response.data.Pregunta.Respuesta3
            this.respuesta4 = response.data.Pregunta.Respuesta4
            this.categoriaPregunta = response.data.Pregunta.CompetenciaPreguntaId
            this.autoevaluacion = response.data.Pregunta.Autoevaluacion
            this.subordinados = response.data.Pregunta.ASubordinado
            this.superiores = response.data.Pregunta.ASuperior
            this.iguales = response.data.Pregunta.AIgual
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }
    },
    watch: {
      todos: function (val) {
        if (val) {
          this.autoevaluacion = true
          this.subordinados = true
          this.superiores = true
          this.iguales = true
        }
      },
      pregunta: function (val) {
        this.preguntaValido = this.validarTextArea(val)
      },
      respuesta1: function (val) {
        this.respuesta1Valido = this.validarTextArea(val)
      },
      respuesta2: function (val) {
        this.respuesta2Valido = this.validarTextArea(val)
      },
      respuesta3: function (val) {
        this.respuesta3Valido = this.validarTextArea(val)
      }, respuesta4: function (val) {
        this.respuesta4Valido = this.validarTextArea(val)
      }, idPreguntaComputed(newP, oldP) {
        // Our fancy notification (2).idFormatoCuestionarioComputed
        if (newP != null) {
          this.idPregunta = newP
        }
        if (newP == 0) {
          this.pregunta = ""
          this.categoriaPregunta = "0"
          this.respuesta1 = ""
          this.respuesta2 = ""
          this.respuesta3 = ""
          this.respuesta4 = ""
          this.autoevaluacion = false
          this.iguales = false
          this.superiores = false
          this.subordinados = false
          this.todos = false
        }
      }

    }, computed: {
      deshabilitarBoton: function () {
        return !this.preguntaValido || !this.respuesta1Valido || !this.respuesta2Valido || !this.respuesta3Valido || !this.respuesta4Valido || this.validarTipoCuestionario || this.categoriaPregunta == ""
      },
      validarTipoCuestionario: function () {
        return !this.autoevaluacion && !this.subordinados && !this.superiores && !this.iguales
      }
    },
    created: function () {
      this.buscarCompetenciasPreguntas();
    },
    mounted: function () {

    }
  }

</script>

<style scoped>
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Psicologia/NuevaPregunta.vue